module.exports = __webpack_public_path__ + "img/icon_play01.c7a312f0.png";